module.exports = __webpack_public_path__ + "297939065ffdf19827f20beda93dcb2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/pants-design.jpg
// module id = 793
// module chunks = 0